import { render, staticRenderFns } from "./BackHomeButton.vue?vue&type=template&id=cdbd137a&scoped=true&"
import script from "./BackHomeButton.vue?vue&type=script&lang=js&"
export * from "./BackHomeButton.vue?vue&type=script&lang=js&"
import style0 from "./BackHomeButton.vue?vue&type=style&index=0&id=cdbd137a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbd137a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
